import { HourMinutesSecondsInterface } from '../Interfaces/HourMinutesSeconds';

export function getTimerWithDistanceMinutesSeconds(
	initialDate,
	final
): HourMinutesSecondsInterface {
	var initial = new Date(initialDate).getTime();
	var distance = initial - final;
	var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	var seconds = Math.floor((distance % (1000 * 60)) / 1000);

	return {
		distance: distance,
		minutes: minutes,
		seconds: seconds,
	};
}
